/**
 * Kurzes Admin-Passwort ohne verwechselbare oder parser-kritische Zeichen.
 *
 * Ausgeschlossen u. a.: 0/O/o, 1/l/I/i sowie Sonderzeichen ($ ` " ' \ & | ; …),
 * die in Shell, JSON oder Copy-Paste leicht Probleme machen.
 */
const UPPER = 'ABCDEFGHJKLMNPQRSTUVWXYZ';
const LOWER = 'abcdefghjkmnpqrstuvwxyz';
const DIGITS = '23456789';
const ALL = UPPER + LOWER + DIGITS;

const DEFAULT_LENGTH = 10;

function randomIndex(maxExclusive) {
    if (maxExclusive <= 0) {
        throw new Error('maxExclusive must be positive');
    }
    const limit = Math.floor(0x100000000 / maxExclusive) * maxExclusive;
    const buf = new Uint32Array(1);
    let value;
    do {
        crypto.getRandomValues(buf);
        value = buf[0];
    } while (value >= limit);
    return value % maxExclusive;
}

function pickChar(alphabet) {
    return alphabet.charAt(randomIndex(alphabet.length));
}

function shuffle(chars) {
    for (let i = chars.length - 1; i > 0; i -= 1) {
        const j = randomIndex(i + 1);
        const tmp = chars[i];
        chars[i] = chars[j];
        chars[j] = tmp;
    }
    return chars;
}

/**
 * @param {number} [length=10]
 * @returns {string}
 */
export function generatePassword(length = DEFAULT_LENGTH) {
    const size = Math.max(4, Number(length) || DEFAULT_LENGTH);
    const chars = [
        pickChar(UPPER),
        pickChar(LOWER),
        pickChar(DIGITS),
    ];
    while (chars.length < size) {
        chars.push(pickChar(ALL));
    }
    return shuffle(chars).join('');
}

export async function copyTextToClipboard(text) {
    if (!text) {
        return false;
    }
    if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(text);
        return true;
    }
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.left = '-9999px';
    document.body.appendChild(ta);
    ta.select();
    let ok = false;
    try {
        ok = document.execCommand('copy');
    } finally {
        document.body.removeChild(ta);
    }
    return ok;
}
